import createStore from "astrid-helpers/src/createStore";
export const [getSearch, setSearch, useSearch, onSearch] = createStore("");
//# sourceMappingURL=search.js.map